import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AuthRoutes from "./routes/AuthRoutes";
import useAuth from "./hooks/useAuth";
import Dashboard from "./components/Dashboard";

import "bootstrap/dist/css/bootstrap.min.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./App.css";

import OrganizationRoutes from "./routes/OrganizationRoutes";
import EmployeeRoutes from "./routes/EmployeeRoutes";
import ExpensesRoutes from "./routes/ExpensesRoutes";
import TaskRoutes from "./routes/TaskRoutes";
import InvoiceRoutes from "./routes/InvoiceRoutes";
import BulkDownloadRoutes from "./routes/BulkDownloadRoutes";
import IncomeRebate from "./routes/IncomeRebate";
import UnpaidInvsRoutes from "./routes/UnpaidInvsRoutes";
import ContractRoutes from "./routes/ContractRoutes";
import ContractInvsRoutes from "./routes/ContractInvsRoutes";
import SearchRoute from "./routes/SearchRoute";
import LogoutHandler from "./components/LogoutHandler";
import QuotationRoutes from "./routes/QuotationRoutes";

function App() {
  const auth = useAuth();
  const user = auth.getCurrentUser();

  return (
    <Routes>
      {/* Logout route */}
      <Route path="/logout" element={<LogoutHandler />} />

      {/* Authenticated routes */}
      {user ? (
        <Route
          path="/*"
          element={
            <Dashboard>
              <Routes>
                <Route path="search/*" element={<SearchRoute />} />
                <Route
                  path="organizations/*"
                  element={<OrganizationRoutes />}
                />
                <Route path="employees/*" element={<EmployeeRoutes />} />
                <Route path="quotations/*" element={<QuotationRoutes />} />
                <Route path="expenses/*" element={<ExpensesRoutes />} />
                <Route
                  path="contract-invs/*"
                  element={<ContractInvsRoutes />}
                />
                <Route path="tasks/*" element={<TaskRoutes />} />
                <Route path="bulkDownload/*" element={<BulkDownloadRoutes />} />
                {/* <Route path="invoices/*" element={<InvoiceRoutes />} /> */}
                <Route path="contracts/*" element={<ContractRoutes />} />
                <Route path="unpaid-invs/*" element={<UnpaidInvsRoutes />} />
                <Route path="income_and_rebate/*" element={<IncomeRebate />} />

                {/* Redirect root to /organizations */}
                <Route
                  index
                  element={<Navigate to="/organizations" replace />}
                />
              </Routes>
            </Dashboard>
          }
        />
      ) : (
        // Unauthenticated routes
        <Route path="/*" element={<AuthRoutes />} />
      )}
    </Routes>
  );
}

export default App;
